import { render, staticRenderFns } from "./DevIncome.vue?vue&type=template&id=4a81416e&scoped=true&"
import script from "./DevIncome.vue?vue&type=script&lang=js&"
export * from "./DevIncome.vue?vue&type=script&lang=js&"
import style0 from "./DevIncome.vue?vue&type=style&index=0&id=4a81416e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81416e",
  null
  
)

export default component.exports